import { render } from "./SwaggerPage.vue?vue&type=template&id=ee305088"
import script from "./SwaggerPage.vue?vue&type=script&lang=js"
export * from "./SwaggerPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__